import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';

import { processOpenApplication } from './processOpenApplication';
import { useSuspenseStateKey } from '../../../hooks/useStateKey.hook';

export function useSuspenseApplicationProcessor({
  applicationStatus,
}: {
  applicationStatus?: string;
}) {
  const { stateKey } = useSuspenseStateKey();
  const queryClient = useQueryClient();
  const needsProcessing = applicationStatus === 'open';

  useSuspenseQuery({
    queryKey: ['processOpenApplication', stateKey],
    queryFn: async () => {
      if (!needsProcessing || !stateKey) return null;

      try {
        await processOpenApplication(stateKey);
        await queryClient.invalidateQueries({
          queryKey: ['fetchGetApplication'],
        });
      } catch {
        // Silently handle errors - the dashboard will show the current state
      }

      return null;
    },
  });
}
